import store from './store';
const allowedSilos = ['rey', 'exc'];

export default function SiloSuffix(silo) {
	const user = store.get('user');
	const returnSuffix = user && allowedSilos.includes(user.primary_silo_code);
	const filteredSilo = String(silo).split(',').filter(s=>allowedSilos.includes(s)).join(',')
	return (returnSuffix && filteredSilo) ? `(${filteredSilo}) ` : '';
}
